/**
 * @module components\ghConfirmDialog
 */
import Vue from "vue";
import { Component, Emit, Prop, Watch, Model } from "vue-property-decorator";
import GhCom from "../../plugins/ghui";

@Component
export default class GhConfirmDialog extends Vue {
  private value: boolean = false;
  private title: string = "确定要删除吗?";
  private text: string = "删除后将不能找回，请慎重！";
  private icon: string = "mdi-thermometer-alert";

  private cancel() {
    this.$emit("cancel");
    this.$emit("change", false);
  }

  private submit() {
    this.$emit("submit");
    this.$emit("change", false);
  }

  public dialogConfirm(
    title?: string,
    text?: string,
    icon?: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this.value = true;
      let btnOk = this.$refs.btnOk as Vue;
      let btnCancel = this.$refs.btnCancel as Vue;
      if (title) {
        this.title = title;
      }
      if (text) {
        this.text = text;
      }
      if (icon) {
        this.icon = icon;
      }
      btnOk.$on("click", args => {
        resolve();
        this.value = false;
      });
      btnCancel.$on("click", args => {
        reject();
        this.value = false;
      });
    });
  }
}
